<template>
  <div>
    <CRow>
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="vertical_configuration">
          Vertical Configuration List
        </h1>
        <CCard class="">
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'verticalConfiguration.new'}" v-if="hasPerm('admin.vertical.create')">
                <CButton block color="primary" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <AjaxTable
                :fields="fields"
                :data="verticals"
                :fetch="fetchVerticalList"
            >
              <template #actions="{item}">
                <td class="text-right">
                  <CButton variant="outline" color="primary" class="mr-2"
                           v-if="hasPerm('admin.vertical.update')"
                           @click="$router.push({name: 'verticalConfiguration.edit', params: {id: item.id}})"
                           v-translate translate-context="list.actions"
                  >
                    Edit
                  </CButton>
                  <CButton @click="onDelete(item.id)" variant="outline" color="danger"
                           v-if="hasPerm('admin.vertical.delete')"
                           v-translate translate-context="list.actions"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
            </AjaxTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AjaxTable from "@/domain/core/components/AjaxTable.vue";

export default {
  name: 'ListVerticalConfiguration',
  components: {AjaxTable},
  data() {
    return {
      fields: [
        {key: 'id', label: this.$pgettext('vertical_configuration.list','ID'), _style: 'width:100px;'},
        {key: 'name', label: this.$pgettext('vertical_configuration.list','Name')},
        {key: 'actions', label: this.$pgettext('vertical_configuration.list','Actions'), sorter: false, filter: false}
      ],
    }
  },
  async mounted() {
    await this.fetchConfig({type:'admin'})
  },
  computed: {
    ...mapGetters('verticalConfiguration', [
      'verticals',
    ]),
  },
  methods: {
    ...mapActions('verticalConfiguration', [
      'fetchVerticalList',
      'deleteVertical'
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onDelete(id) {
      this.confirm({
          title: 'Are your sure?',
          message: 'This action is irreversible',
          cb_confirm: async () => {
            await this.deleteVertical(id)
            await this.fetchList()
          }
      })
    }
  }
}
</script>